export const AREAS = [
	'Content',
	'Visuals',
	'Delivery',
	'Connection',
]

export const AREAS_ICONS = {
	'Content': 'Component 242 – 42',
	'Visuals': 'Component 239 – 41',
	'Delivery': 'Component 242 – 43',
	'Connection': 'Component 238 – 14',
};

export const AREAS_COLOR_ICONS = {
	'Content': 'Component 242 – 64',
	'Visuals': 'Component 239 – 72',
	'Delivery': 'Component 242 – 66',
	'Connection': 'Component 238 – 17',
};

export const AREAS_SUBTITLES = {
	'Content': 'Audience-Oriented',
	'Visuals': 'Message-Focused',
	'Delivery': 'Persuasive and Confident',
	'Connection': 'Engaged and Authentic',
};

export const AREAS_TIPS = {
	'Content': 'Focus your content on what the audience wants—and needs—to know.',
	'Visuals': 'Create compelling visuals that succinctly present your messages.',
	'Delivery': 'Rehearse-rehearse-rehearse until you can deliver your talk with confidence and style.',
	'Connection': 'Master the communication tools you need to connect with your audience.',
};